import type { FeatureStyleNode } from '../feature-style.model';

export interface WavelengthParams {
  of: string;
}

export const WAVELENGTH_DEFAULTS: FeatureStyleNode = {
  line: { color: 'teal', strokeWidth: 2, dash: 0 },
};
